#import "../../../common/graphql/SecureRowLevelsEntityFields.graphql"

query ApprovalSetupFlowCommonData {
  invoiceStatusTypes {
    nodes {
      id
      statusType
    }
  }
  approvalTypes(orderBy: APPROVAL_TYPE_ASC) {
    nodes {
      id
      approvalType
    }
  }
  approvalLevelValues(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  companyCurrencies(orderBy: ISO_CODE_ASC) {
    nodes {
      id
      isoCode
      name
    }
  }
  userGroups(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  statusTypes(
    orderBy: ID_ASC
    filter: { isApprovalHintOverride: { equalTo: true } }
  ) {
    nodes {
      id
      statusType
    }
  }
  activeProfiles(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  corporateWorkgroups(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  userRankTypes(orderBy: USER_RANK_ASC) {
    nodes {
      id
      _rowTimestamp
      userRank
      sortOrder
      _isUpdatable
      _isDeletable
    }
  }
  userOccupationTitles(orderBy: [SORT_ORDER_ASC, USER_OCCUPATION_TITLE_ASC]) {
    nodes {
      id
      userOccupationTitle
      sortOrder
    }
  }
  users(orderBy: NAME_ASC) {
    nodes {
      id
      name
      emailAccount
    }
  }
  companies(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  businessUnits(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  companyPurchaseOrderTypes(orderBy: [IS_DEFAULT_DESC, SORT_ORDER_ASC]) {
    nodes {
      id
      purchaseOrderTypeId
      purchaseOrderType
    }
  }
  approvalPhases {
    nodes {
      id
      phaseName
    }
  }
  departments(
    orderBy: NAME_ASC
    filter: { _isSystemInternal: { notEqualTo: true } }
  ) {
    nodes {
      id
      name
    }
  }
  tags(
    orderBy: BADGE_NAME_ASC
    filter: {
      _isSystemGenerated: { notEqualTo: true }
      isPrivate: { notEqualTo: true }
    }
  ) {
    nodes {
      id
      badgeName
    }
  }
  departmentTypes(orderBy: DEPARTMENT_TYPE_ASC) {
    nodes {
      id
      departmentType
    }
  }
  departmentGroups(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  secureRowLevels(orderBy: NAME_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
  exchangeRateTypes(orderBy: ID_ASC) {
    nodes {
      id
      phaseName
    }
  }
  approverDelayTypes(
    orderBy: ID_ASC
    filter: { _isDelayRule: { equalTo: true } }
  ) {
    nodes {
      id
      delayType
      _isDelayRule
    }
  }
  approverTransactionTypes(orderBy: APPROVAL_TRANSACTION_TYPE_ASC) {
    nodes {
      id
      approvalTransactionType
    }
  }
  userDistributionLists(
    orderBy: USER_NAME_ASC
    filter: { isContactGroup: { equalTo: true }, userId: { isNull: false } }
  ) {
    nodes {
      userId
      userName
      userOccupation
    }
  }
}
